module.exports = __webpack_public_path__ + "static/img/panda.641ad209.webp";